import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC, useRef } from 'react';
import DynamicHotelRooms from './DynamicHotelRooms';
import { RoomClass } from 'ts/hotel/interfaces/HotelResponse';
import useRecaptcha from 'hooks/useRecaptcha';
import { changeHotel } from 'services/dynamic';
import { showError } from 'utils/utils';
import { useTranslation } from 'react-i18next';
import { ChangeHotelResponse } from 'ts/dynamic/interfaces/DynamicResponse';
import MaximizeModal from 'components/shared/MaximizeModal';
import ScreenshotSupport from 'components/shared/ScreenshotSupport';
import useDraggableModal from 'hooks/useDraggableModal';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface ChooseRoomModalProps {
  roomClasses: RoomClass[];
  choosenRoomPrice: number;
  numberOfPax: number;
  selectedRoom?: RoomClass;
  onSelectNewHotel: (arg: ChangeHotelResponse) => void;
  isLoading: boolean;
  hotel?: any;
  onClose: () => void;
  onCloseSuccess: () => void;
  searchToken: string;
}

const ChooseRoomModal: FC<ChooseRoomModalProps> = (props) => {
  const { t } = useTranslation();
  const { handleRecapcha } = useRecaptcha();
  const modalOverlayRef = useRef<HTMLDivElement>(null);
  const { modalRef, modalStyle, dragHandleProps, isDragging } = useDraggableModal(true);
  const onChangeHotel = async (hotel: any, room: any) => {
    const token = await handleRecapcha();
    if (!token) return;

    const response = await changeHotel(token, props.searchToken, hotel, room);
    if (response && !response.hasErrors && response.hotelChanged) {
      props.onSelectNewHotel(response);
    } else {
      showError(response?.errorMessage || t('error'));
    }
  };
  return (
    <div
      className="modal-overlay modal-overlay-top modal-maximizable"
      ref={modalOverlayRef}
      onClick={(e) => e.target === e.currentTarget && props.onClose()}
    >
      <div ref={modalRef} className="modal active" style={modalStyle}>
        <div
          className={'modal-title draggable-modal-handle' + (isDragging ? ' dragging' : '')}
          {...dragHandleProps}
        >
          <div className="title mb-5">{t('dyn.choose_room')}</div>
          <div data-no-drag="true">
            <ScreenshotSupport />
            <MaximizeModal modalOverlayRef={modalOverlayRef} />
            <FontAwesomeIcon icon={faTimes} onClick={() => props.onClose()} className="cur-poi" />
          </div>
        </div>
        <div className="modal-body dyn-room-modal" dir="ltr">
          <DynamicHotelRooms
            rooms={props.roomClasses}
            goToDetails={() => {}}
            showRooms={true}
            selectedRoomPrice={props.choosenRoomPrice}
            numberOfPax={props.numberOfPax}
            selectedRoomId={props.selectedRoom?.rcUniqueKey}
            onClickChange={(rc) => onChangeHotel(props.hotel!, rc)}
            isLoading={props.isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(ChooseRoomModal, 'ChooseRoomModal');
